// Servicio de autenticación para la versión web de ToPack
import { 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword,
  signOut,
  updateProfile,
  sendPasswordResetEmail
} from 'firebase/auth';
import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../firebase/config';

// Registrar un nuevo usuario
export const registerUser = async (email, password, name, phone) => {
  try {
    // Crear usuario en Firebase Auth
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    
    // Actualizar el perfil con el nombre
    await updateProfile(user, { displayName: name });
    
    try {
      // Crear documento de usuario en Firestore (users)
      await setDoc(doc(db, 'users', user.uid), {
        id: user.uid,
        name: name,
        email: email,
        phone: phone,
        created_at: serverTimestamp(),
        last_active: serverTimestamp()
      });
      
      // Crear perfil de usuario en Firestore (user_profiles)
      await setDoc(doc(db, 'user_profiles', user.uid), {
        id: user.uid,
        name: name,
        email: email,
        phone: phone,
        photoUrl: '',
        description: '',
        rating: 0.0,
        total_loads: 0,
        completed_loads: 0,
        pack_coins: 0,
        favorites: [],
        created_at: serverTimestamp(),
        updatedAt: Date.now()
      });
    } catch (firestoreError) {
      console.error('Error al crear documento de usuario en Firestore:', firestoreError);
      // Aunque falle la creación de documentos en Firestore, 
      // la autenticación ya fue creada, así que devolvemos el usuario
    }
    
    return user;
  } catch (error) {
    console.error('Error al registrar usuario:', error);
    throw error;
  }
};

// Iniciar sesión
export const loginUser = async (email, password) => {
  if (!email || !password) {
    const error = new Error('Email y contraseña son obligatorios');
    error.code = 'auth/invalid-credential';
    throw error;
  }

  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return userCredential.user;
  } catch (error) {
    console.error('Error al iniciar sesión:', error);
    throw error;
  }
};

// Cerrar sesión
export const logoutUser = async () => {
  try {
    await signOut(auth);
    return true;
  } catch (error) {
    console.error('Error al cerrar sesión:', error);
    throw error;
  }
};

// Obtener usuario actual
export const getCurrentUser = () => {
  return auth.currentUser;
};

// Obtener perfil de usuario
export const getUserProfile = async (userId) => {
  try {
    // Intentar obtener el perfil de user_profiles
    const userProfileDoc = await getDoc(doc(db, 'user_profiles', userId));
    
    if (userProfileDoc.exists()) {
      return { id: userProfileDoc.id, ...userProfileDoc.data() };
    }
    
    // Si no existe en user_profiles, intentar en users
    const userDoc = await getDoc(doc(db, 'users', userId));
    
    if (userDoc.exists()) {
      return { id: userDoc.id, ...userDoc.data() };
    }
    
    // Si no existe en ninguna colección
    throw new Error('Usuario no encontrado');
  } catch (error) {
    console.error('Error al obtener perfil de usuario:', error);
    throw error;
  }
};

// Restablecer contraseña
export const resetPassword = async (email) => {
  try {
    await sendPasswordResetEmail(auth, email);
    return true;
  } catch (error) {
    console.error('Error al enviar correo de restablecimiento:', error);
    throw error;
  }
};